import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import TV from "./TV";
import TVSettings from "./TVSettings";

const pathname = window.location.pathname;

let Component;
if (pathname.startsWith("/tv/ayar")) {
  Component = TVSettings;
} else if (pathname.startsWith("/tv")) {
  Component = TV;
} else {
  Component = App;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Component />
  </React.StrictMode>,
);
